'use client';

import { RadioGroup } from '@shared/shared-shadcn-ui';
import { StepNumber } from '../step-number/step-number';
import { FormRadioButton } from '../form-radio-button/form-radio-button';
import { FormButton } from '../../../../../../../_libs/components/components';
import { useState } from 'react';
import ArrowRightIcon from '../../../../../../../../../public/svg/arrow-right.svg';

type Properties = {
  onContinue: () => void;
};

const WoundDurationStep = ({ onContinue }: Properties) => {
  const [selectedWoundDuration, setSelectedWoundDuration] = useState<
    string | null
  >(null);

  return (
    <div>
      <div className="flex lg:ml-[50px] xl:ml-[150px] gap-x-6 items-center bg-white rounded-t-lg py-10">
        <StepNumber number={4} />
        <h4 className="text-[30px] lg:text-[44px] text-ogn-blue font-bold leading-normal">
          How long have you had this wound?
        </h4>
      </div>
      <RadioGroup
        value={selectedWoundDuration}
        onValueChange={(value) => setSelectedWoundDuration(value)}
      >
        <div className="grid grid-cols-1 lg:grid-cols-[repeat(2,_minmax(260px,_1fr))] justify-center lg:max-w-[760px] mx-auto gap-y-6 gap-x-12">
          <FormRadioButton label="0-3 months" value="1" />
          <FormRadioButton label="3-6 months" value="2" />
          <FormRadioButton label="6-12 months" value="3" />
          <FormRadioButton label="12+ months" value="4" />
        </div>
      </RadioGroup>
      <FormButton
        className="mx-auto w-[300px] my-16 font-roboto-condensed"
        onClick={onContinue}
        isDisabled={!selectedWoundDuration}
      >
        Next
        <ArrowRightIcon className="w-6 h-6" />
      </FormButton>
    </div>
  );
};

export { WoundDurationStep };
